import React, { useState, useEffect, useRef } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import ModalHeader from "../../../common/ModalHeader";
import ModalFooter from "../../../common/ModalFooter";
import ModalBody from "../../../common/ModalBody";
import { useTranslation } from "react-i18next";
import Constants from "../../../../common/Constants";
import { ConfirmationModal } from "../../../common/ConfirmationModal";

const DepartmentModal = (props) => {
  let [name, setName] = useState("");
  let [edit, setEdit] = useState(false);
  let [id, setId] = useState("");
  const [validate, setValidate] = useState(false);
  let [status, setStatus] = useState("Active");
  const { t } = useTranslation();
  const formRef = useRef(null);
  const [statusConfirmModel, setStatusConfirmModel] = useState(false);

  useEffect(() => {
    if (props.data.deptCode) {
      setName(props?.data?.deptName);
      setId(props?.data?.deptCode);
      setStatus(props?.data?.status);
      setEdit(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleStatus = (event) => {
    setStatus(event.target.value);
    if (event.target.value === "Inactive") {
      setStatusConfirmModel(true);
    }
  };
  const handleSave = (event) => {
    const form = formRef.current;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidate(true);
      return;
    } else {
      setValidate(false);
      const deptObj = {
        deptName: name,
        deptCode: id,
        status: status,
      };
      if (edit) {
        deptObj._id = props.data._id;
      }
      props.onSave(deptObj, edit);
      setName("");
      setId("");
      setEdit(false);
    }
  };

  const handleCancel = (event) => {
    setName("");
    setId("");
    props.onHide();
  };

  const { show, onHide } = props;
  return (
    <>
      <Modal show={show} onHide={onHide} animation={false} backdrop="static">
        <ModalHeader
          title={ edit ? t("msg_master_list.msg_department.edit_page_title") : t("msg_master_list.msg_department.page_title")}
        ></ModalHeader>
        <ModalBody>
          <Form noValidate validated={validate} ref={formRef}>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label className="col-form-label">
                {t("msg_master_list.msg_department.code")} :
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="e.g: DEPT-001"
                value={id || ""}
                onChange={(e) => setId(e.target.value?.trim()?.toUpperCase())}
                required
                maxLength={Constants.MASTER.VALIDATION.maxLengthCode}
                autoFocus
              />
              <Form.Control.Feedback type="invalid">
                {t("msg_master_list.msg_department.department_code_validation")}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label className="col-form-label">
                {" "}
                {t("msg_master_list.msg_department.department_name")} :
              </Form.Label>
              <Form.Control
                type="text"
                value={name || ""}
                onChange={(e) => setName(e.target.value)}
                maxLength={Constants.MASTER.VALIDATION.maxLengthName}
                required
              />
              <Form.Control.Feedback type="invalid">
                {t("msg_master_list.msg_department.department_name_validation")}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label className="col-form-label">
                {t("msg_common.status")} :
              </Form.Label>
              <Form.Select
                aria-label="select status"
                value={status}
                onChange={handleStatus}
              >
                <option value="Active">{t("msg_common.active")}</option>
                <option value="Inactive">{t("msg_common.inactive")}</option>
              </Form.Select>
            </Form.Group>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button
            type="button"
            variant="success"
            className="btn btn-success"
            onClick={handleSave}
          >
            {t("msg_common.save")}
          </Button>
          <Button
            type="button"
            variant="danger"
            className="btn btn-danger"
            onClick={handleCancel}
            data-dismiss="modal"
          >
            {t("msg_common.cancel")}
          </Button>
        </ModalFooter>
      </Modal>

      {statusConfirmModel && (
        <ConfirmationModal
          show={statusConfirmModel}
          heading={t("msg_common.confirmation")}
          bodyMessage={t(
            "msg_master_list.msg_department.status_change_message"
          )}
          onOk={() => setStatusConfirmModel(false)}
          onHide={() => setStatusConfirmModel(false)}
          type={"common"}
        ></ConfirmationModal>
      )}
    </>
  );
};

export default DepartmentModal;
